module.exports = __webpack_public_path__ + "img/9S.50caac18.png";